module.exports = __webpack_public_path__ + "img/user-icon-hover.6981de2d.svg";